import React, { useEffect, useState } from 'react';
import { Paper } from '@mui/material';
import { getJwtToken } from '../../services/jwt.services';
import jwt_decode from 'jwt-decode';
import styles from './Home.module.css';
import GsdSectionTitle from '../../components/GSDSectionTitle/GSDSectionTitle';
import GsdAppBarItems from '../../components/GSDAppBarItems/GSDAppBarItems';
import { getMenuConfiguration } from '../../config/menuConfig';

const Home = () => {
	const [permissions, setPermssiosn] = useState([]);
	const [sendgridpermissions, setSendgridpermissions] = useState([]);
	const [dashboardpermissions, setDashboardpermissions] = useState([]);
	const [twitterxpermissions, setTwitterxpermissions] = useState([]);
	const [entitlementPermissions, setEntitlementPermissions] = useState([]);
	const [intercomPermissions, setIntercomPermissions] = useState([]);
	const [mediarelationspermissions, setMediarelationspermissions] = useState([]);
	const [companiespermissions, setCompaniespermissions] = useState([]);
	const [auth0permissions, setAuth0permissions] = useState([]);
	const [scriptRunnerv2permissions, setScriptRunnerv2permissions] = useState([]);
	const [groups, setGroups] = useState([]);

	useEffect(() => {
		const jwtToken = getJwtToken();
		console.log({ message: 'JWT Token Retrieved', jwtToken });
		if (jwtToken) {
			const {
				permissions,
				sendgridpermissions,
				dashboardpermissions,
				twitterxpermissions,
				entitlementpermissions,
				intercompermissions,
				mediarelationspermissions,
				companiespermissions,
				auth0permissions,
				scriptRunnerv2permissions,
				groups,
			} = jwt_decode(jwtToken);
			console.log({ permissions, groups, entitlementpermissions });
			setPermssiosn(permissions || 'none');
			setSendgridpermissions(sendgridpermissions || 'none');
			setDashboardpermissions(dashboardpermissions || 'none');
			setTwitterxpermissions(twitterxpermissions || 'none');
			setEntitlementPermissions(entitlementpermissions || 'none');
			setIntercomPermissions(intercompermissions || 'none');
			setMediarelationspermissions(mediarelationspermissions || 'none');
			setCompaniespermissions(companiespermissions || 'none');
			setAuth0permissions(auth0permissions || []);
			setScriptRunnerv2permissions(scriptRunnerv2permissions || []);
			setGroups(groups || []);
		}
	}, []);

	// Get menu configuration from shared config
	const { AdminTools, objExplorer, mwTools, IST_Tools } = getMenuConfiguration(
		permissions,
		sendgridpermissions,
		dashboardpermissions,
		twitterxpermissions,
		entitlementPermissions,
		intercomPermissions,
		mediarelationspermissions,
		companiespermissions,
		auth0permissions,
		groups,
		scriptRunnerv2permissions
	);

	const sortByTitle = (items) =>
		[...items].sort((a, b) =>
			(a.title || '').localeCompare(b.title || '', undefined, { sensitivity: 'base' })
		);

	const mwToolsVisible = sortByTitle(
		mwTools.filter((oneitem) => oneitem.show !== false)
	);
	const istToolsVisible = sortByTitle(
		IST_Tools.filter((oneitem) => oneitem.show !== false)
	);
	const objExplorerVisible = sortByTitle(
		objExplorer.filter((oneitem) => oneitem.show !== false)
	);
	const adminToolsVisible = sortByTitle(
		AdminTools.filter((oneitem) => oneitem.show !== false)
	);

	const companyEntitlementTools = [
	{
		href: '/company-management',
		startIcon: 'business',
		title: 'Company Workspace',
		text: 'Manage companies, entitlements, overrides and audit history from a single workspace.',
		show: companiespermissions.includes('admin'),
	},
];

	const companyEntitlementToolsVisible = companyEntitlementTools.filter(
		(oneitem) => oneitem.show !== false
	);

	return (
		<div className={styles.Home}>
			<Paper className={styles.mainPaperStyle} elevation={0}>
				<div className={styles.divStyle}>
					<div className={styles.pageHeader}>
						<p className={styles.pageSubtitle}>Your central hub for Meltwater support tools and utilities</p>
					</div>

					{mwToolsVisible.length > 0 && (
						<React.Fragment>
							<GsdSectionTitle title='Meltwater Tools'></GsdSectionTitle>
							<GsdAppBarItems
								applications={mwToolsVisible}
							></GsdAppBarItems>
						</React.Fragment>
					)}

					{istToolsVisible.length > 0 && (
						<React.Fragment>
							<GsdSectionTitle title='Internal Support Tools (Other Groups)'></GsdSectionTitle>
							<GsdAppBarItems
								applications={istToolsVisible}
							></GsdAppBarItems>
						</React.Fragment>
					)}

					{objExplorerVisible.length > 0 && (
						<React.Fragment>
							<GsdSectionTitle title='MW Object Explorer'></GsdSectionTitle>
							<GsdAppBarItems applications={objExplorerVisible}></GsdAppBarItems>
						</React.Fragment>
					)}
					{companyEntitlementToolsVisible.length > 0 && (
						<React.Fragment>
							<GsdSectionTitle title='Company & Entitlement Administration'></GsdSectionTitle>
							<GsdAppBarItems applications={companyEntitlementToolsVisible}></GsdAppBarItems>
						</React.Fragment>
					)}

					{adminToolsVisible.length > 0 && permissions.includes('admin') && (
						<React.Fragment>
							<GsdSectionTitle title='Admin Tools'></GsdSectionTitle>
							<GsdAppBarItems applications={adminToolsVisible}></GsdAppBarItems>
						</React.Fragment>
					)}

				</div>
			</Paper>
		</div>
	);
};

export default Home;
